import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";

interface Props {
	message?: string;
}

interface State {

}

class FullMessagePopup extends Component<Props, State> {
	render() {
		return <Popup id={ "FullMessage" } title={ Strings.message } showIcon={ false }>
			{ this.props.message }
		</Popup>;
	}
}

export default FullMessagePopup;
